const rusDays = ["пн", "вт", "ср", "чт", "пт", "сб", "вс"];

const rusMonths = [
  "Январь",
  "Февраль",
  "Март",
  "Апрель",
  "Май",
  "Июнь",
  "Июль",
  "Август",
  "Сентябрь",
  "Октябрь",
  "Ноябрь",
  "Декабрь",
];

const rusMonthsDative = [
  "Января",
  "Февраля",
  "Марта",
  "Апреля",
  "Мая",
  "Июня",
  "Июля",
  "Августа",
  "Сентября",
  "Октября",
  "Ноября",
  "Декабря",
];

export const getRusDay = (day) => {
  return rusDays[day];
};

export const getRusMonthDative = (month) => {
  if (month < 1 || month > 12) {
    return rusMonthsDative[0];
  }
  return rusMonthsDative[month - 1];
};

export const getRusMonth = (month) => {
  return rusMonths[month - 1];
};

export const getDaysInMonth = (month, year) => {
  return new Date(year, month, 0).getDate();
};

export const getWeekAgo = (date) => {
  const day = date.getDate() - (date.getDay() - 7);
  return new Date(date.setDate(day));
};

export const checkDateLength = (date) => {
  if (date.toString().length === 1) {
    return `0${date}`;
  } else {
    return date;
  }
};
